<template>
  <div id="timeline-members-map" style="width: 100%; height: 100%"></div>
</template>

<script>
import centroids from "../../assets/centroids.json";
export default {
  props: {
    map: {
      type: Object,
    },
    year: {
      required: true,
    },
    globeActive: {
      type: Boolean,
      default: false,
    },
    visibleMembers: {
      type: Array,
      required: true,
    },
  },
  computed: {
    spin() {
      return this.year === 2024 ? true : false;
    },
  },
  watch: {
    map(map) {
      if (map) this.init();
    },
    spin(curr) {
      const { map } = this;
      if (curr) {
        map.flyTo({
          pitch: 0,
          center: [0, 30],
          zoom: 2.8,
          speed: 0.8,
        });
        let filter = map
          .getStyle()
          .layers.find((d) => d.id === "centroids").filter;
        map.setPaintProperty("centroids", "circle-color", "#04f");
        map.setFilter("labels", filter);
        map.setLayoutProperty("labels", "visibility", "visible");
      } else {
        map.stop();
      }
    },
    globeActive(curr) {
      const { visibleMembers, map, year } = this;
      if (year === 2024) return;
      let fadeIn = {
        pitch: 30,
        center: [0, 30],
        zoom: 2.4,
        speed: 0.8,
      };
      let fadeOut = {
        ...fadeIn,
        center: [140, 30],
        zoom: year === 1974 && visibleMembers.length === 0 ? 0 : 2.3,
      };
      if (visibleMembers.length > 0) {
        const ISO3 = visibleMembers[visibleMembers.length - 1];
        const coord = centroids.find((d) => d.ISO3 === ISO3);
        fadeIn = { ...fadeIn, center: [coord.lon, coord.lat + 10] };
        fadeOut = { ...fadeOut, center: [coord.lon, coord.lat + 10] };
        map
          .setPaintProperty("centroids", "circle-color", [
            "match",
            ["get", "ISO3"],
            [ISO3],
            "#6f6f6f",
            "#6f6f6f",
          ])
          .setLayoutProperty("labels", "visibility", "none");
      }
      map.flyTo(curr ? fadeIn : fadeOut);
    },
    visibleMembers(curr, prev) {
      if (curr.length > 0 && curr.length > prev.length) {
        this.pivotGlobe(curr);
      }
      this.highlightCountry(curr);
    },
  },
  methods: {
    init() {
      const { map } = this;
      map.on("load", () => {
        map
          .addSource("source", {
            type: "vector",
            url: "mapbox://iea.0d031uf2",
          })
          .addLayer({
            id: "centroids",
            type: "circle",
            "source-layer": "countries_centroids-7ofmat",
            source: "source",
            layout: { visibility: "none" },
            paint: {
              "circle-color": "#04f",
              "circle-radius": 5,
            },
          })
          .addLayer({
            id: "labels",
            type: "symbol",
            "source-layer": "countries_centroids-7ofmat",
            source: "source",
            layout: {
              visibility: "none",
              "text-field": ["to-string", ["get", "region"]],
            },
            paint: {
              "text-translate": [0, -20],
              "text-halo-color": "hsl(0, 0%, 100%)",
              "text-halo-width": 1,
            },
          });
        map.on("moveend", () => this.spinGlobe());
      });
    },

    spinGlobe() {
      const { map, spin } = this;
      const secondsPerRevolution = 60;
      // Above zoom level 5, do not rotate.
      const maxSpinZoom = 5;
      // Rotate at intermediate speeds between zoom levels 3 and 5.
      const slowSpinZoom = 3;
      const zoom = map.getZoom();
      if (spin && zoom < maxSpinZoom) {
        let distancePerSecond = 360 / secondsPerRevolution;
        if (zoom > slowSpinZoom) {
          // Slow spinning at higher zooms
          const zoomDif = (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
          distancePerSecond *= zoomDif;
        }
        const center = map.getCenter();
        center.lng -= distancePerSecond;
        // Smoothly animate the map over one second.
        // When this animation is complete, it calls a 'moveend' event.
        map.easeTo({ center, duration: 1000, easing: (n) => n });
      }
    },
    pivotGlobe(curr) {
      const ISO3 = curr[curr.length - 1];
      const coord = centroids.find((d) => d.ISO3 === ISO3);
      this.map.flyTo({
        pitch: 30,
        center: [coord.lon, coord.lat + 10],
        zoom: 2.4,
        speed: 0.8,
      });
    },
    highlightCountry(curr) {
      const { map } = this;
      if (curr.length > 0) {
        const ISO3 = curr[curr.length - 1];
        map
          .setLayoutProperty("centroids", "visibility", "visible")
          .setLayoutProperty("labels", "visibility", "visible")
          .setFilter("centroids", [
            "all",
            ["match", ["get", "ISO3"], curr, true, false],
          ])
          .setFilter("labels", [
            "all",
            ["match", ["get", "ISO3"], [ISO3], true, false],
          ])
          .setPaintProperty("centroids", "circle-color", [
            "match",
            ["get", "ISO3"],
            [ISO3],
            "#04f",
            "#6f6f6f",
          ]);
      } else {
        map.setLayoutProperty("centroids", "visibility", "none");
        map.setLayoutProperty("labels", "visibility", "none");
      }
    },
  },
};
</script>

<style></style>
